import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';

import Link from 'components/common/Link';
import Button from 'components/common/Button';

const styles = theme => ({
  root: {
    paddingLeft: 16,
    paddingRight: 8,
    paddingTop: 16,
    marginTop: -16,
    marginRight: -8,
    marginLeft: -8,
    position: 'sticky',
    top: 64,
    zIndex: 3,
    overflow: 'hidden',
    backgroundColor: theme.palette.grey[100],
    [theme.breakpoints.down('sm')]: {
      top: 56,
      paddingTop: 8,
      paddingBottom: 8,
      marginBottom: 0,
      marginTop: -10,
    },
  },
  grid: {
    [theme.breakpoints.down('sm')]: {
      overflowY: 'auto',
    },
  },
  link: {
    justifyContent: 'space-between',
    marginTop: 14,
    position: 'relative',
    zIndex: 2,
    flexWrap: 'wrap',
    maxWidth: '100%',
    boxSizing: 'border-box',
    height: 32,
    padding: '0 24px',
    display: 'inline-block',
    alignItems: 'flex-start',
    fontWeight: 700,
    color: theme.palette.grey[600],
    '&:after': {
      content: '""',
      position: 'absolute',
      top: -32,
      bottom: -52,
      left: 10,
      right: 10,
      zIndex: -100,
      backgroundColor: theme.palette.primary.A100,
      transform: 'perspective(200px) rotateX(40deg)',
      boxShadow: theme.shadows[7],
    },
  },
  linkActive: {
    '&:after': {
      backgroundColor: theme.palette.common.white,
    },
  },
});

const InventoryNavigation = ({ location, width, classes }) => (
  <Toolbar
    className={classes.root}
    disableGutters
  >
    <Grid
      className={classes.grid}
      container
      justify="space-between"
      alignItems="center"
      wrap="nowrap"
      spacing={0}
    >
      {(width !== 'xs' && width !== 'sm') && (
        <Grid item>
          <Link
            className={classNames(classes.link, {
              [classes.linkActive]: location.pathname === '/inventory/products',
            })}
            href="/inventory/products"
            size="md"
          >
            Products
          </Link>
          <Link
            className={classNames(classes.link, {
              [classes.linkActive]: location.pathname === '/inventory/vendors',
            })}
            href="/inventory/vendors"
            size="md"
          >
            Vendor
          </Link>
  {/*        <Link
            className={classNames(classes.link, {
              [classes.linkActive]: location.pathname === '/inventory/purchase',
            })}
            href="/inventory/purchase"
            size="md"
            disabled
          >
            Purchase Orders
          </Link>*/}
        </Grid>
      )}
      <Grid item>
        {(width === 'xs' || width === 'sm') && (
          <Fragment>
            <Button
              nav
              href="/inventory/products"
            >
              Products
            </Button>
            <Button
              nav
              href="/inventory/vendors"
            >
              Vendor
            </Button>
          </Fragment>
        )}
        <Button
          nav
          href="/inventory/categories"
        >
          Categories
        </Button>
        <Button
          nav
          href="/inventory/conditions"
        >
          Condition
        </Button>
        <Button
          nav
          href="/inventory/warehouses"
        >
          Warehouse
        </Button>
      </Grid>
    </Grid>
  </Toolbar>
);

InventoryNavigation.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};


export default withStyles(styles)(withWidth()(InventoryNavigation));



// WEBPACK FOOTER //
// ./src/components/inventory/InventoryNavigation/InventoryNavigation.js